class Customer {
  name: string;

  id: string | null;

  deletedAt: string | null;

  constructor(name: string, id: string | null = null, deletedAt: string | null = null) {
    this.name = name;
    this.id = id;
    this.deletedAt = deletedAt;
  }
}

export default Customer;
